export default defineNuxtRouteMiddleware(async (to) => {
    // Get locale from cookie
    const locale = getCookie('i18n_redirected') ?? 'en'
    // List of locales (en is the default locale - no prefix in URL)
    const locales = ["en", "sv", "fr", "ch", "da", "nl", "no", "de", "dk"];
    const defaultLocale = "en";
    // Removes empty parts like '' from '//'
    const pathSegments = to.path.split("/").filter(Boolean);
    // Remove locales from path and retrieve only paths part of the routes
    const pathWithoutLocales = pathSegments.filter((segment) => !locales.includes(segment));

    // If second path segment is a locale for example in cases when we append /de/de/ or /de/sv/ | sv/fr/ etc...
    // Update the route to only one locale segment -> /de/path
    // Or when first path segment is not equal to the current locale
    const hasDoubleLocale = locales.includes(pathSegments[1]);
    const pathLocaleMismatchesCookie = locales.includes(pathSegments[0]) && pathSegments[0] !== locale;

    // Case 1: URL already has a locale prefix, but it's wrong or duplicated
    if (hasDoubleLocale || pathLocaleMismatchesCookie) {
        // Default locale (en) should not have a prefix in the URL (prefix_except_default strategy)
        const newPath = locale === defaultLocale
            ? `/${pathWithoutLocales.join('/')}`
            : `/${locale}/${pathWithoutLocales.join('/')}`;
        return navigateTo({ path: newPath, query: to.query, hash: to.hash }, { replace: true });
    }

    // Case 2: URL has NO locale prefix, but cookie locale is NON-default
    // Example: path = /dashboard/activity-log, cookie = 'de'
    // We must redirect to /de/dashboard/activity-log, otherwise page will render in default 'en'
    if (!locales.includes(pathSegments[0]) && locale !== defaultLocale) {
        const newPath = `/${locale}/${pathWithoutLocales.join('/')}`;
        return navigateTo({ path: newPath, query: to.query, hash: to.hash }, { replace: true });
    }
})